

































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import { ClienteServiceAdapter, VoucherServiceAdapter } from '@/usecases'
import DataTablePaginado, {
	OnBuscarParam,
} from '@/components/ui/data-tables/DataTablePaginado.vue'
import { AxiosRequestConfig } from 'axios'
import { FormVoucher, Page, Voucher } from '@/models'
import { ObserveVisibility } from 'vue-observe-visibility'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { formatarMoeda } from '@/shareds/formatadores'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { voucherEstaExpirado } from '@/shareds/cliente-shareds'
import DialogoVoucherAvulso from '@/components/voucher/DialogoVoucherAvulso.vue'

@Component({
	components: {
		DataTablePaginado,
		Confirmacao,
		DialogoVoucherAvulso,
	},
	directives: {
		ObserveVisibility,
	},
})
export default class ListagemDeVouchers extends Vue {
	@Ref() dataTable!: DataTablePaginado
	@Ref() confirmacaoDeInativarVoucher!: Confirmacao
	@Ref() dialogoDeVoucher!: DialogoVoucherAvulso
	@Prop({ type: String }) clienteId!: string

	@Inject('VoucherServiceAdapter')
	private voucherService!: VoucherServiceAdapter

	@Inject('ClienteServiceAdapter')
	private clienteService!: ClienteServiceAdapter

	formatarMoeda = formatarMoeda
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	carregando = false
	pagina: Page<Voucher> | null = null
	paginaAtual = 1
	selecionado: Voucher | null = null
	expirado = false
	voucherEstaExpirado = voucherEstaExpirado

	headers = [
		{ text: 'Gerado em', value: 'dataHoraGeracao', width: 'auto' },
		{ text: 'Valor', value: 'valor', width: 'auto' },
		{ text: 'Situação', value: 'situacao', width: 'auto' },
		{ text: 'Expira em', value: 'expiracao', with: 'auto' },
		{
			text: 'Ações',
			value: 'acoes',
			width: 'auto',
			sorteable: false,
			align: 'center',
		},
	]

	get buscar(): OnBuscarParam {
		return (params: any, config?: AxiosRequestConfig) =>
			this.clienteService.getVouchers(this.clienteId, {
				sort: 'dataHoraGeracao,desc',
				expirado: this.expirado,
			}, config)
	}

	novoVoucher() {
		this.dialogoDeVoucher.mostrar()
	}

	async salvarVoucher(voucher: FormVoucher) {
		try {
			this.dialogoDeVoucher.saving()
			await this.clienteService.addVoucher(voucher)
			this.dialogoDeVoucher.saving(false)
			this.dialogoDeVoucher.esconder()
			this.dataTable.reiniciar()
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	exibeConfirmacao(item: Voucher) {
		if (item.situacao == 'Inutilizado') {
			AlertModule.setError(
				'Não é possível inutilizar um voucher já inutilizado!',
			)
		} else {
			this.selecionado = JSON.parse(JSON.stringify(item))
			this.confirmacaoDeInativarVoucher.mostrar()
		}
	}

	async inutilizarVoucher(item: any) {
		if (!item) return
		try {
			item.situacao = 'Inutilizado'
			await this.voucherService.update(item)
			const indice = this.pagina?.content.findIndex(voucher => voucher.id === item.id)
			if (indice !== undefined && indice !== -1) {
				this.pagina?.content.splice(indice, 1, item)
				AlertModule.setSuccess('Voucher inativado com sucesso')
			}
		} catch (e) {
			AlertModule.setError(e)
		}finally{
			this.dataTable.reiniciar()
		}
	}

	obterSubtituloDeInativacao() {
		if (!this.selecionado) return ''
		return `Feito em ${dateTimeToPtBrFormat(this.selecionado.dataHoraGeracao)}`
	}

	@Watch('expirado')
	onChangeExpirado() {
		this.dataTable.reiniciar()
	}
}
